export const COLOR = {
  bg: '#FAF7F2',
  text: '#332626',
  subtext: '#A09991',
  border: '#E5DDD4',
  main: '#FA674F',
  mainBorder: '#EF4A3E',
  accent: '#F7B43D',
};
